import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";
import {
  AddIpBlocklistRequest,
  IpBlocklistActionResponse,
  IpBlocklistListParams,
  IpBlocklistListResponse,
  RemoveIpBlocklistRequest,
} from "../models/IpManagement/IpBlocklistModel";

class IpBlocklistService {
  private api: AxiosInstance;

  constructor() {
    this.api = createApiClient();
  }

  public async listBlockedIps(
    params: IpBlocklistListParams = {}
  ): Promise<IpBlocklistListResponse> {
    const response = await this.api.get<IpBlocklistListResponse>(
      "/adminPanel/ipBlocklist/list",
      { params }
    );
    return response.data;
  }

  public async addIp(
    data: AddIpBlocklistRequest
  ): Promise<IpBlocklistActionResponse> {
    const response = await this.api.post<IpBlocklistActionResponse>(
      "/adminPanel/ipBlocklist/add",
      data
    );
    return response.data;
  }

  public async removeIp(
    data: RemoveIpBlocklistRequest
  ): Promise<IpBlocklistActionResponse> {
    const response = await this.api.post<IpBlocklistActionResponse>(
      "/adminPanel/ipBlocklist/remove",
      data
    );
    return response.data;
  }
}

export const ipBlocklistService = new IpBlocklistService();
